// Mobile drawer menu: animate the submenu on both open and close.
// Native <details> hides its content the instant the `open` attribute
// changes, so a CSS-only transition can only ever animate one direction
// reliably. This intercepts the summary click, animates the actual content
// height (no fixed cap, so tall submenus never clip), and only then flips
// `open`. Desktop is left untouched, reduced-motion users skip the
// animation, and re-clicking mid-animation reverses direction cleanly
// instead of stacking timers or getting stuck.
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var DURATION_MS = 600; // keep in sync with the transition below
  var animations = new WeakMap();

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animate(details, content, opening) {
    var running = animations.get(details);
    var startHeight;

    if (running) {
      // Continuing from a live animation: content is already open/rendered
      // (opening a <details> always flips `open` immediately), so its
      // current offsetHeight is a safe midpoint to resume from.
      startHeight = content.offsetHeight;
      running.cancel();
    } else if (opening) {
      // Fresh open from an idle, fully closed <details>: a closed <details>
      // hides its children natively, so scrollHeight can't be trusted until
      // `open` is set. Pin the collapsed state first, then open, then measure.
      content.style.transition = 'none';
      content.style.maxHeight = '0px';
      details.open = true;
      void content.offsetHeight; // flush the collapsed state before measuring
      startHeight = 0;
    } else {
      // Fresh close from an idle, fully open <details>.
      startHeight = content.offsetHeight;
    }

    if (opening) details.open = true; // no-op if already set above

    var endHeight = opening ? content.scrollHeight : 0;

    if (prefersReducedMotion()) {
      content.style.maxHeight = '';
      content.style.transition = '';
      if (!opening) details.open = false;
      return;
    }

    var cancelled = false;
    var timeoutId;

    var onTransitionEnd = function (event) {
      if (event.target === content && event.propertyName === 'max-height') finish();
    };
    var finish = function () {
      if (cancelled) return;
      cancelled = true;
      clearTimeout(timeoutId);
      content.removeEventListener('transitionend', onTransitionEnd);
      content.style.maxHeight = '';
      content.style.transition = '';
      if (!opening) details.open = false;
      animations.delete(details);
    };

    animations.set(details, {
      opening: opening,
      cancel: function () {
        if (cancelled) return;
        cancelled = true;
        clearTimeout(timeoutId);
        content.removeEventListener('transitionend', onTransitionEnd);
        content.style.maxHeight = '';
        content.style.transition = '';
        animations.delete(details);
      },
    });

    content.style.transition = 'none';
    content.style.maxHeight = startHeight + 'px';
    // Force reflow so the browser registers the start height before animating.
    void content.offsetHeight;
    content.style.transition = 'max-height ' + DURATION_MS + 'ms ease';

    content.addEventListener('transitionend', onTransitionEnd);
    timeoutId = setTimeout(finish, DURATION_MS + 100);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (cancelled) return;
        content.style.maxHeight = endHeight + 'px';
      });
    });
  }

  function onSummaryClick(event) {
    if (!isMobile()) return;

    var summary = event.currentTarget;
    var details = summary.closest('details');
    if (!details) return;

    var content = details.querySelector(':scope > .details-content');
    if (!content) return;

    event.preventDefault();

    // While an animation is in flight, `details.open` stays true for the
    // whole close transition, so it can't tell us which way to reverse.
    // The in-flight animation's own recorded direction can.
    var running = animations.get(details);
    var opening = running ? !running.opening : !details.open;
    animate(details, content, opening);
  }

  function init() {
    document.querySelectorAll('.menu-drawer summary.menu-drawer__menu-item').forEach(function (summary) {
      summary.addEventListener('click', onSummaryClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
